module.exports = __webpack_public_path__ + "img/SunleiGraduate.0d13dd0c.png";